import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosApi } from "../../helpers/AxiosApi";
import { toast } from "react-toastify";
import initialStates from "./state";

// get Dashboard
export const getDashboard = createAsyncThunk(
  "getDashboard",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`dashboard`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Tickets List
      .addCase(getDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.getDashboardStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getDashboard.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

const { reducer } = dashboardSlice;
export default reducer;
